  import React, { useState, useEffect } from "react";
  import { NavLink, useNavigate } from "react-router-dom";
  import { useDispatch } from "react-redux";
  import { logout } from "../slices/authSlice";
  import { ReactComponent as DashboardIcon } from "../assets/icons/dashboard.svg";
  import { ReactComponent as UsersIcon } from "../assets/icons/users.svg";
  import { ReactComponent as VendorsIcon } from "../assets/icons/vendors.svg";
  import { ReactComponent as PayoutIcon } from "../assets/icons/payout.svg";
  import { ReactComponent as NotificationsIcon } from "../assets/icons/notifications.svg";
  import { ReactComponent as OrdersIcon } from "../assets/icons/orders.svg";
  import { ReactComponent as ProfileIcon } from "../assets/icons/profile.svg";
  import { ReactComponent as LogoutIcon } from "../assets/icons/logout.svg";
  import { ReactComponent as Logo } from "../assets/icons/d_logo.svg";
  import Swal from "sweetalert2"; // Import SweetAlert
  import "./Sidebar.css";

  // Settings icon component
  const SettingsIcon = ({ className }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
  );

  const Sidebar = ({ isOpen, onToggle }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleResize = () => {
      if (window.innerWidth >= 768) {
        // Only open sidebar on desktop resize, don't close it
        if (!isOpen) {
          onToggle();
        }
      }
    };

    const handleLogout = async () => {
      try {
        Swal.fire({
          title: "Are you sure ?",
          text: "Press on Ok if you want to Logout.",
          showCancelButton: true,

          cancelButtonText: "Cancel",
          icon: "question",
          confirmButtonText: "Ok",
        }).then(async (result) => {
          if (result.isConfirmed) {
            await dispatch(logout()).unwrap();
            console.log("Logout successful");
            navigate("/login");
          }
        });
      } catch (err) {
        console.error("Logout failed:", err);
      }
    };

    useEffect(() => {
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, [isOpen]);

    return (
      <>
        <div className="md:hidden flex items-center justify-between p-4 bg-secondary shadow-lg fixed w-full z-20">
          <button
            onClick={onToggle}
            className="text-white focus:outline-none"
          >
            {isOpen ? "Close" : "Menu"}
          </button>
          <Logo className="w-8 h-8" />
        </div>
        <div
          className={`fixed h-full custom-gradient-bg transition-all duration-300 z-10`}
          style={{
            width: isOpen ? '256px' : '0px',
            overflow: isOpen ? 'visible' : 'hidden'
          }}
        >
          {isOpen && (
            <div className="p-6">
              <div className="flex items-center justify-between">
                <Logo className="w-10 h-10" />
                  <button
                    onClick={onToggle}
                    className="bg-secondary-light hover:bg-accent-dark text-white px-3 py-2 rounded-lg transition-colors duration-200 flex items-center"
                  >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              <div className="text-white text-lg mb-4 h-[calc(100vh-150px)] overflow-y-auto scrollbar-hide">
              <nav className="mt-10 space-y-4">
                <NavLink
                  to="/"
                  className={({ isActive }) =>
                    `flex items-center px-6 py-4 mb-3 text-white text-base rounded-lg ${
                      isActive ? "selected-option-bg" : "hover:bg-gray-700"
                    }`
                  }
                >
                  <DashboardIcon className="w-6 h-6 mr-3" />
                  <span>Dashboard</span>
                </NavLink>

              <NavLink
                to="/users"
                className={({ isActive }) =>
                  `flex items-center px-6 py-4 mb-3 text-white text-base rounded-lg ${
                    isActive ? "selected-option-bg" : "hover:bg-gray-700"
                  }`
                }
              >
                <UsersIcon className="w-6 h-6 mr-3" />
                <span>Users</span>
              </NavLink>

      <NavLink
        to="/vendors"
        className={({ isActive }) =>
          `flex items-center px-6 py-4 mb-3 text-white text-base rounded-lg ${
            isActive ? "selected-option-bg" : "hover:bg-gray-700"
          }`
        }
      >
        <VendorsIcon className="w-6 h-6 mr-3" />
        <span>Vendors</span>
      </NavLink>

      <NavLink
        to="/Category"
        className={({ isActive }) =>
          `flex items-center px-6 py-4 mb-3 text-white text-base rounded-lg ${
            isActive ? "selected-option-bg" : "hover:bg-gray-700"
          }`
        }
      >
        <OrdersIcon className="w-6 h-6 mr-3" />
        <span>Category</span>
      </NavLink>

      <NavLink
        to="/vendors-payout"
        className={({ isActive }) =>
          `flex items-center px-6 py-4 mb-3 text-white text-base rounded-lg ${
            isActive ? "selected-option-bg" : "hover:bg-gray-700"
          }`
        }
      >
        <PayoutIcon className="w-6 h-6 mr-3" />
        <span>Vendor's Payout</span>
      </NavLink>

      <NavLink
        to="/notifications"
        className={({ isActive }) =>
          `flex items-center px-6 py-4 mb-3 text-white text-base rounded-lg ${
            isActive ? "selected-option-bg" : "hover:bg-gray-700"
          }`
        }
      >
        <NotificationsIcon className="w-6 h-6 mr-3" />
        <span>Notifications</span>
      </NavLink>

      <NavLink
        to="/orders"
        className={({ isActive }) =>
          `flex items-center px-6 py-4 mb-3 text-white text-base rounded-lg ${
            isActive ? "selected-option-bg" : "hover:bg-gray-700"
          }`
        }
      >
        <OrdersIcon className="w-6 h-6 mr-3" />
        <span>Orders</span>
      </NavLink>

      <NavLink
        to="/settings"
        className={({ isActive }) =>
          `flex items-center px-6 py-4 mb-3 text-white text-base rounded-lg ${
            isActive ? "selected-option-bg" : "hover:bg-gray-700"
          }`
        }
      >
        <SettingsIcon className="w-6 h-6 mr-3" />
        <span>Settings</span>
      </NavLink>

      <NavLink
        to="/profile"
        className={({ isActive }) =>
          `flex items-center px-6 py-4 mb-3 text-white text-base rounded-lg ${
            isActive ? "selected-option-bg" : "hover:bg-gray-700"
          }`
        }
      >
        <ProfileIcon className="w-6 h-6 mr-3" />
        <span>My Profile</span>
      </NavLink>
    </nav>
  </div>

              <div className="border-t border-gray-600 pt-4 mt-4">
                <button
                  onClick={handleLogout}
                  className="flex items-center px-6 py-4 mb-3 text-white text-base rounded-lg"
                >
                  <LogoutIcon className="w-6 h-6 mr-3" />
                  <span>Logout</span>
                </button>
              </div>
            </div>
          )}
        </div>
      </>
    );
  };

  export default Sidebar;
